import { render, staticRenderFns } from "./addCodebook.vue?vue&type=template&id=5ed32b5d&scoped=true&lang=html&"
import script from "./addCodebook.vue?vue&type=script&lang=js&"
export * from "./addCodebook.vue?vue&type=script&lang=js&"
import style0 from "./addCodebook.vue?vue&type=style&index=0&id=5ed32b5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed32b5d",
  null
  
)

export default component.exports